export default __webpack_public_path__ + "65344d8dc6d004aed0ee031bd57b90e7.svg";